<template>
  <div data-v-109a143a="" class="relative w-full">
    <header class="header" data-v-109a143a="">
      <div
        class="flex justify-between items-center h-full mx-auto max-w-7xl"
        data-v-109a143a=""
      >
        <div
          class="flex items-center flex-none justify-center lg:justify-start lg:flex-1"
          data-v-109a143a=""
        >
          <a
            href="/"
            aria-current="page"
            aria-label="homeLink"
            class="nuxt-link-exact-active nuxt-link-active w-130px lg:w-210px"
            data-v-109a143a=""
          >
            <img
              alt="Vue logo"
              class="baichenimg"
              src="@/assets/logo.png"
              style="width: 50px;"
          /></a>
        </div>
        <a-menu :key="locale" mode="horizontal" theme="light">
          <head-nav-item
            v-for="route in displayRoutes"
            :key="`${locale}-${route.path}`"
            :route-obj="route"
          />
        </a-menu>
        <div class="flex items-center justify-end lg:flex-1" data-v-109a143a="">
          <div class="header-actions" data-v-109a143a="">
            <details ref="languageDetails" class="language-details" data-v-109a143a="">
              <summary class="language-trigger" data-v-109a143a="">
                <span class="language-icon" data-v-109a143a="">
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
                    <path d="M3.5 12h17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                    <path
                      d="M12 3c2.7 2.6 4.2 5.8 4.2 9S14.7 18.4 12 21c-2.7-2.6-4.2-5.8-4.2-9S9.3 5.6 12 3Z"
                      stroke="currentColor"
                      stroke-width="1.8"
                    />
                  </svg>
                </span>
                <span data-v-109a143a="">{{ languageLabel }}</span>
              </summary>
              <div class="language-menu" data-v-109a143a="">
                <div
                  v-for="item in languages"
                  :key="item.value"
                  class="language-option"
                  :class="{ active: locale === item.value }"
                  role="button"
                  tabindex="0"
                  @mousedown.prevent="selectLanguage(item.value)"
                  @keydown.enter.prevent="selectLanguage(item.value)"
                  @keydown.space.prevent="selectLanguage(item.value)"
                  data-v-109a143a=""
                >
                  {{ item.label }}
                </div>
              </div>
            </details>

            <div class="desktop-buttons" data-v-109a143a="">
              <el-button plain @click="login()">{{ texts.login }}</el-button>
              <el-button type="primary" @click="gratis()">{{ texts.register }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
// import store from '@/store'
import { mapGetters } from "vuex";
import HeadNavItem from "@/layout/head-nav/HeadNavItem";
import { localeState, setLocale } from "@/utils/locale";
// import { constantRoutes } from '@/router'

/**
 * 头部导航栏
 */
export default {
  name: "HeadNav",
  components: { HeadNavItem },
  data() {
    return {
      routeLabels: {
        zh: {
          Home: "首页",
          Product: "产品",
          price: "价格",
          Ad: "广告",
          AboutUs: "关于",
        },
        en: {
          Home: "Home",
          Product: "Product",
          price: "Pricing",
          Ad: "Advertising",
          AboutUs: "About",
        },
      },
      copy: {
        zh: {
          login: "登录",
          register: "注册",
        },
        en: {
          login: "Sign in",
          register: "Sign up",
        },
      },
      languages: [
        { value: "zh", label: "中文" },
        { value: "en", label: "English" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      routes: "routes/routes",
    }),
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale];
    },
    languageLabel() {
      return this.locale === "en" ? "English" : "中文";
    },
    displayRoutes() {
      return this.routes
        .filter((route) => !route.children && route.desc)
        .map((route) => ({
          ...route,
          desc:
            this.routeLabels[this.locale][route.name] ||
            this.routeLabels[this.locale][route.desc] ||
            route.desc,
        }));
    },
  },
  created() {
    // console.log('head-nav created ====> ', this.routes);
    // 路由初始化
    /*if (this.routes.length === 0) {
      store.dispatch(('routes/setRoutes'), constantRoutes);
    }*/
  },
  methods: {
    /*gotoView(path){
      console.log('跳转 ===> ',path)
      this.$router.push(path)
    }*/
    login() {
      window.location.href =
        this.locale === "en"
          ? "mailto:Lin@whanley.com?subject=Account%20Login%20Inquiry"
          : "mailto:Lin@whanley.com?subject=%E8%B4%A6%E5%8F%B7%E7%99%BB%E5%BD%95%E5%92%A8%E8%AF%A2";
    },
    gratis() {
      window.location.href =
        this.locale === "en"
          ? "mailto:Lin@whanley.com?subject=Account%20Registration%20Inquiry"
          : "mailto:Lin@whanley.com?subject=%E8%B4%A6%E5%8F%B7%E6%B3%A8%E5%86%8C%E5%92%A8%E8%AF%A2";
    },
    selectLanguage(locale) {
      setLocale(locale);
      if (this.$refs.languageDetails) {
        this.$refs.languageDetails.removeAttribute("open");
      }
    },
  },
  mounted() {
    // console.log(JSON.stringify(this.routes))
    console.log("$router ===> ,", this.$router.getRoutes());
    // const urlParams = new URLSearchParams(window.location.search);
    // console.log("123:"+window.location.search);
    
    // const code = urlParams.get('code');
    // if(code){
    //   window.location.href = `http://localhost?code=${code}`;
    // }
  },
};
</script>

<style scoped>
@media (min-width: 1024px) {
  .header[data-v-109a143a] {
    height: 4rem;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 1024px) {
  .lg\:flex-1 {
    flex: 1 1 0%;
  }
}
@media (min-width: 1024px) {
  .lg\:justify-start {
    justify-content: flex-start;
  }
}
.header[data-v-109a143a] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  height: 3.75rem;
  padding-left: 15px;
  padding-right: 15px;
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: 0 2px 10px 0 rgba(180, 189, 221, 0.25);
  transition: top 0.2s ease;
}
.ant-menu-horizontal {
  line-height: 46px;
  white-space: nowrap;
  border: 0;
  box-shadow: none;
}
.max-w-7xl {
  max-width: 80rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.h-full {
  height: 100%;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.flex {
  display: flex;
}
.baichenimg {
  width: 120px;
  padding-bottom: 2px;
}
.header-actions {
  align-items: center;
  display: flex;
  gap: 14px;
}
.desktop-buttons {
  display: flex;
  gap: 10px;
}
.language-details {
  position: relative;
}
.language-details[open] .language-trigger {
  background: rgba(37, 84, 254, 0.08);
}
.language-trigger {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 999px;
  color: #2554fe;
  cursor: pointer;
  display: inline-flex;
  font-size: 17px;
  font-weight: 600;
  gap: 10px;
  min-height: 44px;
  padding: 10px 16px;
  position: relative;
  z-index: 121;
  list-style: none;
  user-select: none;
}
.language-trigger::-webkit-details-marker {
  display: none;
}
.language-trigger:hover {
  background: rgba(37, 84, 254, 0.06);
}
.language-icon {
  display: inline-flex;
  height: 20px;
  width: 20px;
}
.language-icon svg {
  height: 100%;
  width: 100%;
}
:deep(.language-dropdown-popper.el-popper) {
  display: none !important;
}
.language-menu {
  background: #fff;
  border: 1px solid rgba(36, 53, 88, 0.08);
  border-radius: 10px;
  box-shadow: 0 16px 38px rgba(45, 76, 156, 0.14);
  left: 50%;
  min-width: 210px;
  padding: 12px 0;
  position: absolute;
  top: calc(100% + 16px);
  transform: translateX(-50%);
  z-index: 130;
}
.language-menu::before {
  background: #fff;
  border-left: 1px solid rgba(36, 53, 88, 0.08);
  border-top: 1px solid rgba(36, 53, 88, 0.08);
  content: "";
  height: 16px;
  left: 50%;
  position: absolute;
  top: -9px;
  transform: translateX(-50%) rotate(45deg);
  width: 16px;
}
.language-option {
  background: transparent;
  border: 0;
  color: #20263d;
  cursor: pointer;
  display: block;
  font-size: 23px;
  font-weight: 500;
  line-height: 1.2;
  padding: 16px 32px;
  text-align: left;
  width: 100%;
}
.language-option.active {
  color: #2554fe;
  font-weight: 700;
}
.language-option:hover {
  background: rgba(37, 84, 254, 0.05);
}
.justify-end {
  justify-content: flex-end;
}
.items-center {
  align-items: center;
}
.w-full {
  width: 100%;
}
.relative {
  position: relative;
}
@media (max-width: 1023px) {
  .desktop-buttons {
    display: none;
  }
}
</style>
